import { SUM } from '__jsLibs/EXCEL';
const gettersOperatingExpenses = {
	PropertyMgmtCosts(state, getters) {
		if (
			getters.TotalRevenues
			&& getters.TotalRevenues !== 0
			&& state.result['property_management']
			&& state.result['property_management'] !== ''
		) {
			return (getters.TotalRevenues * state.result['property_management']) / 100;
		}
		return 0;
	},
	CapExReservCosts(state, getters) {
		if (
			getters.TotalRevenues
			&& getters.TotalRevenues !== 0
			&& state.result['cap_ex_reserve']
			&& state.result['cap_ex_reserve'] !== ''
		) {
			return (getters.TotalRevenues * state.result['cap_ex_reserve']) / 100;
		}
		return 0;
	},
	VacancyReserveCosts(state, getters) {
		if (
			getters.TotalRevenues
			&& getters.TotalRevenues !== 0
			&& state.result['vacancy_reserve']
			&& state.result['vacancy_reserve'] !== ''
		) {
			return (getters.TotalRevenues * state.result['vacancy_reserve']) / 100;
		}
		return 0;
	},
	RepairsReserveCosts(state, getters) {
		if (
			getters.TotalRevenues
			&& getters.TotalRevenues !== 0
			&& state.result['repairs_reserve']
			&& state.result['repairs_reserve'] !== ''
		) {
			return (getters.TotalRevenues * state.result['repairs_reserve']) / 100;
		}
		return 0;
	},
	PropertyMgmtAnnual(state, getters) {
		if (getters.PropertyMgmtCosts && getters.PropertyMgmtCosts !== 0) {
			return 12 * getters.PropertyMgmtCosts;
		}
		return 0;
	},
	CapExReservAnnual(state, getters) {
		if (getters.CapExReservCosts && getters.CapExReservCosts !== 0) {
			return 12 * getters.CapExReservCosts;
		}
		return 0;
	},
	VacancyReserveAnnual(state, getters) {
		if (getters.VacancyReserveCosts && getters.VacancyReserveCosts !== 0) {
			return 12 * getters.VacancyReserveCosts;
		}
		return 0;
	},
	RepairsReserveAnnual(state, getters) {
		if (getters.RepairsReserveCosts && getters.RepairsReserveCosts !== 0) {
			return 12 * getters.RepairsReserveCosts;
		}
		return 0;
	},
	TotalOperatingExpensesCosts(state, getters) {
		return SUM([
			+state.result['water'],
			+state.result['electric'],
			+state.result['trash'],
			+state.result['other_expenses'],
			+getters.PropertyMgmtCosts,
			+getters.CapExReservCosts,
			+getters.VacancyReserveCosts,
			+getters.RepairsReserveCosts
		]);
	},
	TotalOperatingExpensesPercentage(state, getters) {
		return SUM([
			+state.result['property_management'],
			+state.result['cap_ex_reserve'],
			+state.result['vacancy_reserve'],
			+state.result['repairs_reserve']
		]);
	},
	TotalOperatingExpensesAnnual(state, getters) {
		return SUM([
			+getters.CapExReservAnnual,
			+getters.VacancyReserveAnnual,
			+getters.RepairsReserveAnnual
		]);
	}
};
export {
	gettersOperatingExpenses
};
